export interface initialStateInterface {
  hexa: number
  reex: number
  octa: number
  ethos: number
  hepta: number
  terra: number
  dominion: number
  loyalty: number
  onegm: number
}

export const initialState: initialStateInterface = {
  hexa: 0,
  reex: 0,
  octa: 0,
  ethos: 0,
  hepta: 0,
  terra: 0,
  dominion: 0,
  loyalty: 0,
  onegm: 0,
}
